import { Engine, Scene, TargetCamera } from "babylonjs";

class Store {
  private _canvas?: HTMLCanvasElement;
  private _engine?: Engine;
  private _scene?: Scene;
  private _mainCamera?: TargetCamera;
  private _screenshotCamera?: TargetCamera;
  private _screenshot = "";

  public set canvas(canvas) {
    this._canvas = canvas;
  }

  public get canvas(): HTMLCanvasElement {
    return this._canvas as HTMLCanvasElement;
  }

  public set engine(engine) {
    this._engine = engine;
  }

  public get engine(): Engine {
    return this._engine as Engine;
  }

  public set scene(scene) {
    this._scene = scene;
  }

  public get scene(): Scene {
    return this._scene as Scene;
  }

  public set mainCamera(camera) {
    this._mainCamera = camera;
  }

  public get mainCamera(): TargetCamera {
    return this._mainCamera as TargetCamera;
  }

  public set screenshotCamera(camera) {
    this._screenshotCamera = camera;
  }

  public get screenshotCamera(): TargetCamera {
    return this._screenshotCamera as TargetCamera;
  }

  public set screenshot(value) {
    this._screenshot = value;
  }

  public get screenshot(): string {
    return this._screenshot as string;
  }
}

export default new Store();
